import { BreakoutButton } from 'components/design-system/BreakoutButton'
import { Dialog } from 'components/dialogs/Dialog'
import { DialogCloseButton } from 'components/dialogs/DialogCloseButton'
import { useTranslationTyped } from 'i18n/i18n'
import type { Section } from '@breakoutlearning/firebase-repository/models/Section'
import { useRootStore } from 'hooks/rootStore'
import { useDialogs } from 'hooks/dialogs'

export const SampleClassesDialog = ({
  sampleSections,
}: {
  sampleSections: Section[]
}) => {
  const { tt } = useTranslationTyped()
  const store = useRootStore()
  const { popDialog } = useDialogs()

  return (
    <Dialog
      size="xl"
      className="flex flex-col items-center"
      innerClassName="flex flex-col !w-[550px]"
    >
      <DialogCloseButton />
      <div className="mb-4 text-center text-headline-large">
        {tt.navigation.help_menu.sample_classes()}
      </div>

      <div className="flex flex-col items-stretch">
        <div className="max-h-[500px] overflow-y-auto">
          {sampleSections.map((section) => (
            <div
              key={section.id}
              className="mb-3 flex items-center justify-between gap-2 rounded-xl bg-surface px-5 py-4"
            >
              <div className="flex flex-col gap-1">
                <div className="text-title-medium">
                  {section.data.className}
                </div>
                <div className="text-body-large text-on-surface-var">
                  {section.data.sectionName}
                </div>
              </div>
              <BreakoutButton
                kind="accent"
                size="small"
                onClick={() => {
                  store.navigateTo('instructorClass', { id: section.id })
                  popDialog()
                }}
              >
                {tt.instructor_classes.view()}
              </BreakoutButton>
            </div>
          ))}
        </div>
      </div>
    </Dialog>
  )
}
